module.exports = __webpack_public_path__ + "b85a5bd406747739fd89d6640771c269.png";